/**
 * panelDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

panelDirective.$inject = [];

export function panelDirective() {
    return {
        scope: {
            isOpen: '=?open',
            initiallyOpen: '=?initiallyOpen',
            label: '@label',
            showButton: '=?showButton',
            preventToggle: '=?preventToggle',
        },
        transclude: {
            content: '?appPanelContent',
            toggle: '?appPanelToggle',
        },
        //language=HTML
        template: `
            <div ng-transclude="toggle"
                 ng-click="toggle()"
                 class="panel-toggle"
                 ng-class="{ 'panel-is-open': isOpen }">
                <md-button class="panel-toggle-button"
                           md-no-ink=" true"
                           ng-if="showButton"
                           data-testid="select:dropdown"
                           aria-expanded="{{ isOpen }}"
                           title="Toggle panel">

                    <span class="panel-toggle-label">
                        {{ label }}
                    </span>

                    <span class="md-visually-hidden">
                        Toggle {{ isOpen ? 'expanded' : 'collapsed'}}
                    </span>

                    <md-icon class="panel-toggle-chevron">keyboard_arrow_down</md-icon>
                </md-button>
            </div>

            <div class="panel-content" ng-if="isOpen">
                <ng-template ng-transclude></ng-template>
                <ng-template ng-transclude="content"></ng-template>
            </div>
        `,
        link: function(scope) {
            scope.toggle = toggle;
            scope.showButton = angular.isDefined(scope.showButton) ? scope.showButton : true;

            if (scope.initiallyOpen !== undefined) {
                scope.isOpen = scope.initiallyOpen;
            }

            function toggle() {
                if (scope.preventToggle) {
                    return;
                }

                scope.isOpen = !scope.isOpen;
            }
        },
    };
}
